export default __webpack_public_path__ + "static/media/trophy_blue_gradient.ece7969f.svg";